export default {
  EMERGENCY_FUND_INVESTOR_GOAL_CALCULATOR_REPOSITORY: Symbol.for('EMERGENCY_FUND_INVESTOR_GOAL_CALCULATOR_REPOSITORY'),
  GET_EMERGENCY_FUND_INVESTOR_GOAL_CALCULATOR_QUERY: Symbol.for('GET_EMERGENCY_FUND_INVESTOR_GOAL_CALCULATOR_QUERY'),
  CALCULATE_EMERGENCY_FUND_GOAL_MAXIMUM_MONTHS_QUERY: Symbol.for('CALCULATE_EMERGENCY_FUND_GOAL_MAXIMUM_MONTHS_QUERY'),
};
